import { useTranslation } from 'react-i18next';

export const keyPrefix = 'unblock_user';
export const useUnblockUserTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    button: 'Разблокировать',
    activate_button: 'Активировать',
    toast_success: 'Пользователь успешно разблокирован',
    toast_error: 'Не удалось разблокировать пользователя',
    toast_success_activate: 'Пользователь успешно активирован',
    toast_error_activate: 'Не удалось активировать пользователя',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    button: 'Unblock',
    activate_button: 'Activate',
    toast_success: 'User successfully unblocked',
    toast_error: 'Failed to unblock user',
    toast_success_activate: 'User successfully activated',
    toast_error_activate: 'Failed to activate user',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    button: 'Desbloquear',
    activate_button: 'Ativar',
    toast_success: 'Usuário desbloqueado com sucesso',
    toast_error: 'Falha ao desbloquear o usuário',
    toast_success_activate: 'Usuário ativado com sucesso',
    toast_error_activate: 'Falha ao ativar o usuário',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    button: 'Desbloquear',
    activate_button: 'Activar',
    toast_success: 'Usuario desbloqueado con éxito',
    toast_error: 'Error al desbloquear al usuario',
    toast_success_activate: 'Usuario activado con éxito',
    toast_error_activate: 'Error al activar al usuario',
  },
}) : {}) as Record<string, unknown>;
